export const listUrl = {
  banner: {
    img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/banner/somos-arezzoeco.png",
  },
  brandsCarousel: {
    item: [
      {
        marca: "Alme",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/quadra-verde.png",
          alt: "Alt da imagem",
          title: "Quadra Verde",
          description:
            "Juntas, TROC, Alme, Bemglô e WeNutz criaram um hub sustentável incrível! A Quadra verde, localizada na Rua Oscar Freire, 1105, é um coletivo de marcas sustentáveis que buscam expandir a consciência de consumo e gerar impacto positivo na sociedade. Venha conhecer!  ",
        },
      },
      {
        marca: "SV Recover ",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/teste.jpg",
          alt: "Alt da imagem",
          title: "SV Recover ",
          description:
            "Alme e Reserva lançam tênis agênero, 100% carbono neutro e segue todas as premissas de diminuição de impacto ambiental com tecnologia e inovação. Unimos a tecnologia sustentável e de conforto de Alme com a atitude e estilo praticados pela Reserva. ",
        },
      },
      {
        marca: "Sapatilha 100% vegana Anacapri",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/_22A5912.jpg",
          alt: "Alt da imagem",
          title: "Sapatilha 100% vegana Anacapri ",
          description:
            "Pensando sempre em conforto, bem-estar e em nossa estratégia e melhores práticas de sustentabilidade, desenvolvemos a linha de sapatilhas 100% vegana, certificada pela Sociedade Brasileira Vegetariana. Temos como compromisso.",
        },
      },
      {
        marca: "Alme e Fundação SOS Mata Atlântica  ",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/ALME-0292.png",
          alt: "Alt da imagem",
          title: "Alme e Fundação SOS Mata Atlântica",
          description:
            "A Alme e a SOS Mata Atlântica se uniram para desenvolver um produto que destina 10% do seu lucro para a manutenção de um dos principais biomas brasileiros: a Mata Atlântica. As slides da nossa collab tem certificado vegano e são 100% recicláveis.",
        },
      },
      {
        marca: "Camiseta Simples Reserva",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/camiseta-simples.png",
          alt: "Alt da imagem",
          title: "Camiseta Simples Reserva",
          description:
            "Produzida com 100% de algodão certificado, estimulamos a produção sustentável do algodão e zelamos pela qualidade da fibra. O processo de plantio e cultivo é muito menos agressivo ao meio ambiente - não usa fertilizantes sintéticos e necessita de muito menos água. ",
        },
      },
      {
        marca: "Rastreabilidade Alme",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/ALME-01-_-BRONX1488.png",
          alt: "Alt da imagem",
          title: "Rastreabilidade Alme",
          description:
            "Acompanhamos todas as etapas produtivas dos modelos. Os clientes podem conhecer a jornada do produto acessando um QRCode que traz um mapa das etapas de produção e onde ocorreram, informações sobre os atributos sustentáveis e a pegada de carbono do produto. ",
        },
      },
      {
        marca: "Reserva Circular",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/reserva-circular-logo-200923-nin.png",
          alt: "Alt da imagem",
          title: "Reserva Circular",
          description:
            "Linha de produtos desenvolvida a partir de sobras de tecido que foram desfibrados e tornaram-se tecidos novamente, dando novo significado ao que seria lixo. Essa iniciativa virou um programa robusto com a implantação de logística reversa pós-consumo nas lojas físicas. ",
        },
      },
      {
        marca: "ACV produtos Alme",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/_DSC4894.png",
          alt: "Alt da imagem",
          title: "ACV produtos Alme",
          description:
            "Calculamos a pegada de carbono da nossa produção em cada produto e divulgamos a quantidade equivalente de CO2 liberada em cada Alme, desde a escolha dos materiais, até a fabricação e o transporte. ",
        },
      },
      {
        marca: "TROC Bag",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/posts.png",
          alt: "Alt da imagem",
          title: "TROC Bag",
          description:
            "Já pensou em uma sacola retornável onde você pode fazer a moda ser circular? Com a TROC Bag em mãos, você pode levar os seus desapegos até a loja física ou agendar uma coleta domiciliar. É prático e seguro! ",
        },
      },
      {
        marca: "Alme Retorna",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/_DSC4966.jpg",
          alt: "Alt da imagem",
          title: "Alme Retorna",
          description:
            "Para estimular a circularidade, oferecemos o Alme Retorna, serviço de logística reversa pós-consumo. Nossos clientes podem enviar para nossas lojas Alme sapatos que queiram descartar, e nos comprometemos a dar a destinação correta para esses produtos.",
        },
      },
      {
        marca: "1P=5P",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/1p5p-1a-selecao-alta-7.png",
          alt: "Alt da imagem",
          title: "1P=5P",
          description:
            "Desde 2016, a cada peça vendida na Reserva e Reserva Mini, a empresa doa cinco pratos de comida por meio da Associação Civil Banco de Alimentos e do Projeto Mesa Brasil/SESC.",
        },
      },
      {
        marca: "Arezzo&Co",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/card-logistica-reversa-v2.jpg",
          alt: "Alt da imagem",
          title: "Logística Reversa pós consumo – Arezzo&Co",
          description:
            "Com o programa de Logística Reversa pós-consumo disponibilizamos pontos de coleta nas lojas físicas para que os clientes das marcas - Arezzo e Arezzo Brizza, Schutz, Anacapri, Alme, Reserva, Reserva Go – possam depositar roupas e sapatos que não utilizam mais. Após triagem, destinamos os itens para doação, reutilização ou destinação ambientalmente adequada. Até 2030 queremos implantar pontos de coleta em 100% das lojas do grupo Arezzo&Co fortalecendo a economia circular.",
        },
      },
      {
        marca: "Emissões de Gases de Efeito Estufa – Arezzo&Co",
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/emissao-gases-efeito-estufa.jpg",
          alt: "Alt da imagem",
          title: "Emissões de Gases de Efeito Estufa – Arezzo&Co",
          description:
            "O combate às mudanças climáticas é um tema urgente todo o mundo. Por isso, temos fortalecido nossas iniciativas nesse sentido assinando o Business Ambition for 1,5ºC e Fashion Industry Charter for Climate Action, nos comprometendo a reduzir as emissões de gases de efeito estufa em 30% até 2030 e em 100% até 2050, para limitar o aquecimento global em até 1,5ºC.",
        },
      },
      {
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/reserva-re-use.jpeg",
          alt: "Alt da imagem",
          title: "Reserva Re-use",
          description:
            "Sete calçados ícones da Reserva, em versões mais sustentáveis. Usamos materiais e produtos descartados que deram vida a tênis clássicos que nunca saem de moda. Produzidos a partir de algodão reciclado, linho reciclado, pet reciclado e tênis reciclados. <a href=' https://www.usereserva.com/colecao-go-reserva/linha/classicos-reciclados'>Saiba mais.</a>",
        },
      },
      {
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/programa-afirmativo-v2.jpg",
          alt: "Alt da imagem",
          title: "Programa Afirmativo para pessoas negras",
          description:
            "A Arezzo&Co lançou no início de 2023 o Programa afirmativo de bolsas de estudo para colaboradores negros, que distribuirá 300 bolsas para cursos de graduação, tecnólogos, pós-graduação ou inglês. O objetivo do programa é dar acesso à educação para colaboradores negros de todas as marcas, integrantes do corporativo e fábricas, como um impulsionador na carreira dessas pessoas, permitindo que elas sejam protagonistas das suas próprias histórias.",
        },
      },
      {
        post: {
          img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/posts/desmatamento-zero-v2.jpg",
          alt: "Alt da imagem",
          title: "Desmatamento Zero",
          description:
            'O Grupo Arezzo&Co busca o fim do desmatamento e conversão de ecossistemas relacionados a extração das matérias-primas e busca promover uma transformação positiva na cadeia de valor. Considerando que o couro representa mais de 50% dos calçados, bolsas e acessórios, e também está presente em peças de vestuário, nos unimos a grandes marcas e nos tornamos a primeira e única empresa brasileira a assinar o Deforestation-Free Call to Action for Leather  junto as organizações internacionais Textile Exchange e Leather Working Group., assumindo o compromisso com fim do desmatamento e conversão de ecossistemas da cadeia do couro até 2030. <a href="https://textileexchange.org/leather-call-to-action/">Saiba mais.</a>',
        },
      },
    ],
  },
  commitments: {
    production:
      "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/producao-responsavel-2.png",
    healthyEnvironment:
      "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/Meio ambiente Saudavel.jpeg",
    empoweredPeople:
      "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/empowered-people-3.png",
  },
  commitmentsCarousel: {
    item: [
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/producao-responsavel-2.png",
        title: "Produção Responsável",
        subtitle: [
          {
            text: "100 % da cadeia de fornecedores rastreada e certificada",
          },
          {
            text: "100% de transparência dos produtos para clientes, com informações de composição, origem e fabricação",
          },
          {
            text: "Integrar a carteira ISE B3",
          },
          {
            text: "Estar posicionada entre as top 10 empresas de varejo no Brasil, em índices de sustentabilidade de relevância",
          },
          {
            text: "Reconhecimento das práticas de sustentabilidade das marcas",
          },
        ],
      },
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/Meio ambiente Saudavel.jpeg",
        title: "Meio Ambiente Saudável ",
        subtitle: [
          {
            text: "Neutralização de emissões até 2024 (escopos 1, 2 e 3)",
          },
          {
            text: "100% das embalagens produzidas com material reciclado e/ou biodegradável",
          },
          {
            text: "40% certificação, substituição ou redução de matéria-prima (produtos) por alternativas sustentáveis",
          },
        ],
      },
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/empowered-people-3.png",
        title: "Pessoas Empoderadas",
        subtitle: [
          {
            text: "100% dos fornecedores e colaboradores treinados anualmente em tópicos relevantes",
          },
          {
            text: "Estar entre as 3 melhores empresas de varejo no Brasil e no GPTW Mulher",
          },
          {
            text: "Constante desenvolvimento do quadro de sapateiros",
          },
        ],
      },
    ],
  },
  footer: {
    logoArezzo:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-arezzo.svg",
    logoSchutz:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-schutz.svg",
    logoAnacapri:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-anacapri.svg",
    logoAB:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-ab.svg",
    logoVans:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-vans.svg",
    logoReserva:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-reserva.svg",
    logoZZmal:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-zzmall.svg",
    logoBaw:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-baw.svg",
    logoRange:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/AR&CO-logo.svg",
  },
  header: {
    logoheader:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/logo-arezzo&co.svg",
    burgerheader:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/Vector.png",
    closemodal:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/close-menu-mobile.png",
  },
  logosCarousel: {
    item: [
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-arezzo.svg",
        alt: "logo-arezzo",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-schutz.svg",
        alt: "logo-schutz",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-anacapri.svg",
        alt: "logo-anacapri",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-ab.svg",
        alt: "logo-ab",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-vans.svg",
        alt: "logo-vans",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-reserva.svg",
        alt: "reserva",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-zzmall.svg",
        alt: "logo-zzmall",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-baw.svg",
        alt: "baw",
      },
    ],
  },
  pillars: {
    images: {
      bannerdesk:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/banner-nossos-pilares.jpg",
      bannermobile:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/banner-nossos-pilares.jpg",
      production:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/producao-responsavel.svg",
      communication:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/comunicacao.svg",
      environmentHealthy:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/meio-ambiente.svg",
      empoweredPeople:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/pessoas-empoderadas.svg",
      arrowBottom:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/asset-troca.png",
      arrowmobile:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/arrow.png",
      arrowdesk:
        "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/arrow-continua.png",
    },
    products: [
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/producao-responsavel.svg",
        title: "Produção Responsável ",
        subtitle:
          "Gerar valor para a sociedade a partir do desenvolvimento de uma cadeia ética, responsável, segura e sustentável.",
      },
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/meio-ambiente.svg",
        title: "Meio Ambiente Saudável ",
        subtitle:
          "Desenvolver produtos considerando todo o seu ciclo de vida, sempre priorizando alternativas de menor impacto.",
      },
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/pessoas-empoderadas.svg",
        title: "Pessoas Empoderadas",
        subtitle:
          "Garantir um ambiente inclusivo, seguro e próspero para todos.",
      },
      {
        icon: "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/pillars/comunicacao.svg",
        title: "Comunicação Transparente",
        subtitle:
          "Comunicar com responsabilidade e promover a educomunicação para todos os públicos.",
      },
    ],
  },
  policeSustainability: {
    bannerDesk:
      "https://arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/policy/fundo.png",
    bannerMobile:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/policy/banner-politica-sustentabilidade-mobile.png",
  },
  postsCarousel: {
    products: [
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-arezzo.png",
        alt: "logo-arezzo",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-schutz.png",
        alt: "logo-schutz",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-anacapri.png",
        alt: "logo-anacapri",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-ab.png",
        alt: "logo-ab",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-fiever.png",
        alt: "logo-fiever",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-alme.png",
        alt: "logo-alme",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-vans.png",
        alt: "logo-vans",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/reserva.png",
        alt: "reserva",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-troc.png",
        alt: "logo-troc",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-zzmall.png",
        alt: "logo-zzmall",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/baw.png",
        alt: "baw",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/logo-myshoes.png",
        alt: "logo-myshoes",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/logos/carol-bassi.png",
        alt: "carol-bassi",
      },
    ],
  },
  recognitionCarousel: {
    products: [
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/recognition/iseb3.svg",
        alt: "Em 2022, pela segunda vez consecutiva, fomos selecionados para compor o Índice de Sustentabilidade Empresarial (ISE) da Bolsa de Valores do Brasil (B3), com expressiva evolução na pontuação, atingindo 75,93 pontos. Isso demonstra a solidez na adoção de boas práticas ESG nos posicionando entre as empresas que são referência em sustentabilidade no Brasil.",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/recognition/MicrosoftTeams-image (29).svg",
        alt: "Arezzo&Co e suas subsidiárias foram certificadas pelo GPTW em 2022. E 78% dos nossos colaboradores dizem que somos um ótimo lugar para se trabalhar.",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/recognition/humanizadas.svg",
        alt: "Arezzo&Co foi reconhecida pela pesquisa Melhores Para o Brasil – Humanizadas",
      },
      {
        img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/recognition/logo_sistema_b.png",
        alt: "Em 2022 a Arezzo&Co tornou-se uma empresa B ao conquistar a certificação e Grupo Reserva teve sua certificação renovada. A avaliação tem como base a comprovação de todas as práticas da Companhia nos eixos de Governança, Práticas Trabalhistas, Apoio às Comunidades, Meio Ambiente e Clientes. ",
      },
      {
        img: "https://www.aberje.com.br/wp-content/uploads/2022/06/Exame.jpg",
        alt: "A Arezzo&Co conquistou o 2º lugar na categoria Moda e Vestuário – Melhores e Maiores 2022.",
      },
    ],
  },
  report: {
    img: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/report/Subtract.png",
    icon: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/report/pdf-icon.png",
    iconDown:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/report/icon-down.png",
  },
  trocWrapper: {
    video:
      "https://player.vimeo.com/video/842919196?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    logo: "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/troc/troc.png",
    troc01:
      "https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/troc/troc.jpg",
  },
};
